<script setup lang="ts">
  import { computed } from 'vue';
  import { rowClass, rowFullClass } from './FormSection.css';
  import type { FormSectionRowProps } from './FormSection.types';

  const props = withDefaults(defineProps<FormSectionRowProps>(), {
    full: false,
  });

  const resolvedTestId = computed(() => props.testId ?? 'ds-form-section-row');

  const rowClasses = computed(() => [rowClass, props.full && rowFullClass]);
</script>

<template>
  <div :class="rowClasses" :data-testid="resolvedTestId">
    <slot />
  </div>
</template>
